// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import { getUtcTimestampSeconds } from 'utilities/time'

// Redux:
import { setSeeking, setSeekPercent, seekTo } from 'actions/schedule'

class TrackBar extends React.Component {
	handleSeekMouseDown = () => {
		const { setSeeking } = this.props

		setSeeking( true )
	}

	handleSeekChange = ( e ) => {
		const { setSeekPercent } = this.props

		setSeekPercent( parseFloat( e.target.value ) )
	}

	handleSeekMouseUp = ( e ) => {
		const { seekTo, setSeeking, nowPlaying, canFastForward, futureFastForwardMaxHours } = this.props
		let value = parseFloat( e.target.value )
		let utcTimestampSeconds = getUtcTimestampSeconds()
		let trackDuration = nowPlaying.end_timestamp_gmt - nowPlaying.start_timestamp_gmt
		let canSeek = true

		// Prevent seeking past the allowed hours:
		if ( ! canFastForward ) {
			// Get the offset between the requested seek time and now:
			let seekSeconds = trackDuration * value
			let secondsFromSeekTimeToNow = ( nowPlaying.start_timestamp_gmt + seekSeconds ) - utcTimestampSeconds
			let seekTimeOffsetHours = secondsFromSeekTimeToNow / 60 / 60

			if ( seekTimeOffsetHours >= futureFastForwardMaxHours ) {
				canSeek = false
			}
		}

		if ( ! canSeek ) {
			setTimeout( () => {
				setSeeking( false )
			}, 1000 )

			return
		}

		seekTo( parseFloat( value ) )

		setTimeout( () => {
			setSeeking( false )
		}, 1000 )
	}

	render() {
		let { seekPercent, nowPlaying } = this.props
		let className = '-track-wrap'

		if ( 'undefined' == typeof seekPercent ) {
			seekPercent = ''
		}

		if ( nowPlaying && nowPlaying.is_livestream ) {
			className += ' is-disabled'
		}

		return (
			<div className={ className }>
				<input
					className="-track"
					type='range' min={ 0 } max={ 1 } step='any'
					value={ seekPercent }
					onMouseDown={ this.handleSeekMouseDown }
					onTouchStart={ this.handleSeekMouseDown }
					onChange={ this.handleSeekChange }
					onTouchMove={ this.handleSeekChange }
					onMouseUp={ this.handleSeekMouseUp }
					onTouchEnd={ this.handleSeekMouseUp }
				/>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		nowPlaying: state.schedule.nowPlaying,
		nowPlayingLive: state.schedule.nowPlayingLive,
		seekPercent: state.schedule.seekPercent,
		canFastForward: state.schedule.canFastForward,
		futureFastForwardMaxHours: state.schedule.futureFastForwardMaxHours
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		setSeeking( value ) {
			dispatch( setSeeking( value ) )
		},

		setSeekPercent( value ) {
			dispatch( setSeekPercent( value ) )
		},

		seekTo( value ) {
			dispatch( seekTo( value ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( TrackBar )
